// extracted by mini-css-extract-plugin
export default {"summary-container":"StockTransferReportSummary_summary-container__2894z","summary-ctas":"StockTransferReportSummary_summary-ctas__mKOkk"};